import {
    PRESS_ASSOCIATION_IDENTIFIER,
    PRESS_ASSOCIATION_SHORTHAND,
} from "~constants";
import { Story as StoryType } from "~types/types";

export default function isPressAssociation(story: StoryType) {
    const { byline } = story;

    return (
        byline?.includes(PRESS_ASSOCIATION_IDENTIFIER) ||
        byline?.includes(PRESS_ASSOCIATION_SHORTHAND)
    );
}
